import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [
    ["dias", Math.floor(s / 86400)],
    ["horas", Math.floor((s % 86400) / 3600)],
    ["min", Math.floor((s % 3600) / 60)],
    ["seg", s % 60],
  ];
};

export const Countdown = ({ until, onExpire }) => {
  const end = new Date(until).getTime();
  const [left, setLeft] = useState(() => end - Date.now());

  useEffect(() => {
    const t = setInterval(() => {
      const ms = end - Date.now();
      setLeft(ms);
      if (ms <= 0) {
        clearInterval(t);
        onExpire?.();
      }
    }, 1000);
    return () => clearInterval(t);
  }, [end, onExpire]);

  if (!Number.isFinite(end) || left <= 0) return null;

  return (
    <div data-testid="featured-countdown">
      <p className="mono text-[11px] uppercase tracking-[0.25em] text-amber-300">A oferta termina em</p>
      <div className="mt-3 grid grid-cols-4 gap-2 max-w-sm">
        {parts(left).map(([label, v]) => (
          <div key={label} className="rounded-2xl border border-white/10 bg-black/40 px-2 py-3 text-center">
            <span data-testid={`countdown-${label}`} className="font-display block text-3xl font-extrabold tabular-nums text-white">{pad(v)}</span>
            <span className="mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
